import { useAuth0 } from '@auth0/auth0-react';
import { IconSignOut2 } from '@odekoteam/doppio';
import { navLinkContainer, navLinkLabel } from './styles';

const LogoutButton = (): JSX.Element => {
  const { logout } = useAuth0();

  const handleClick = (): void => {
    // Save persist:delivery from localStorage before clearing
    const persistDelivery = localStorage.getItem('persist:delivery');

    // Clear all localStorage and sessionStorage
    localStorage.clear();
    sessionStorage.clear();

    // Restore persist:delivery if it existed
    if (persistDelivery) {
      localStorage.setItem('persist:delivery', persistDelivery);
    }

    // Clear all cookies except persist:delivery
    document.cookie.split(';').forEach((cookie) => {
      const cookieName = cookie.split('=')[0].trim();
      if (cookieName !== 'persist:delivery') {
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname};`;
      }
    });

    if (process.env.CYPRESS_AUTH_MOCKED === 'true') {
      window.location.href = '/login';
      return;
    }
    logout({ logoutParams: { returnTo: window.location.origin } });
  };
  return (
    <div id="logoutButton" sx={navLinkContainer} onClick={handleClick}>
      <div>
        <IconSignOut2 width={24} height={24} />
      </div>
      <div sx={navLinkLabel}>Log out</div>
    </div>
  );
};

export default LogoutButton;
